<template>
  <div>
<!--    <el-descriptions class="margin-top" :column="1" border>-->
<!--      <el-descriptions-item>-->
        <!-- <template slot="label">
          申请专业方向
        </template>
        <el-input
          placeholder="申请专业方向"
          v-model="project_list.con_1"
          clearable >
        </el-input> -->
<!--      </el-descriptions-item>-->
<!--    </el-descriptions>-->
    <p class="third-title-p">1.过去（动因）</p>
    <el-descriptions  direction="vertical" :column="1" border>
      <el-descriptions-item>
        <template slot="label">
          讲述一下自己为什么选择本科的专业？(如果是跨专业的话，请讲述一下你为什么想跨申该专业)
        </template>
        <el-input type="textarea" v-model="project_list.con_2" rows="6"></el-input>
      </el-descriptions-item>
    </el-descriptions>
    <div v-for="(item) in project_list.major">
      <p  class="third-title-p">2.现在（经历）
        <el-link :underline="false">
          <i class="el-icon-delete" style="margin-left: 15px;color: #0e90d2" @click="del_major(i)"></i>
        </el-link>
      </p>
      <el-descriptions  direction="vertical" :column="1" border>
        <el-descriptions-item>
          <template slot="label">
            项目：科研/课程项目/实习/活动经历
          </template>
          <el-input type="textarea" v-model="item.direction" rows="6"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            你想要从这个项目当中表现你的能力和特质是什么？通过这个项目如何去体现？
          </template>
          <el-input type="textarea" v-model="item.con_1" rows="6"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            在这个项目当中你遇到过什么困难？是怎么克服的？你的成长是什么？通过这个项目你有体会到哪里还是不足的吗？
          </template>
          <el-input type="textarea" v-model="item.con_2" rows="6"></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div style="text-align: left;margin-top: 20px">
      <el-button plain @click="addMajor" >增加</el-button>
    </div>


    <p class="third-title-p">3.未来（学业规划+职业规划）</p>
    <el-descriptions direction="vertical" :column="1" border>
      <el-descriptions-item>
        <template slot="label">
          你未来想从事的行业是什么呢？
        </template>
        <el-input type="textarea" v-model="project_list.con_3" rows="6"></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          你未来的目标公司是哪（几）个呢？
        </template>
        <el-input type="textarea" v-model="project_list.con_4" rows="6"></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          你未来想要从事的岗位是什么？这个岗位的工作内容是什么呢？
        </template>
        <el-input type="textarea" v-model="project_list.con_5" rows="6"></el-input>
      </el-descriptions-item> <el-descriptions-item>
      <template slot="label">
        你认为对于你目标的岗位来说，需要具备哪些专业技能和性格特质呢？
      </template>
      <el-input type="textarea" v-model="project_list.con_6" rows="6"></el-input>
    </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          针对上述你分析出的专业技能和性格特质哪一些是你具有的？哪一些是你不具有的？
        </template>
        <el-input type="textarea" v-model="project_list.con_7" rows="6"></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          希望如何通过硕士阶段更好的帮你达到你的职业目标呢？（可以针对申请不同的项目去填补）
        </template>
        <el-input type="textarea" v-model="project_list.con_8" rows="6"></el-input>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
import tab_referrer from './tab_referrer.vue'

export default {
  name:"TabProject",
  components: {
    tab_referrer
  },
  props: {
    user_profile:{
      default: ''
    }
  },
  watch: {
    'user_profile': {
      handler(val, oldVal) {
        // console.log('传入方向数据：' ,val)
        // console.log('传入方向数据数字：' ,val.length)
        // console.log('传入方向数据类型：' ,typeof val)
        if(val){
          // console.log('进来了：' ,val)
          this.project_list = val
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      project_list: {
        con_1: '',
        con_2: '',
        con_3: '',
        con_4: '',
        con_5: '',
        con_6: '',
        con_7: '',
        con_8: '',
        major: [{
          direction: '',
          con_1: '',
          con_2: ''
        }]
      }
    }
  },
  computed: {
  },
  methods: {
    addMajor() {
      this.project_list.major.push({
        direction: '',
        con_1: '',
        con_2: ''
      })
    },
    del_major(index){
      this.project_list.major.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_project.vue